import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getPriceCategoryFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.price_categories.code.label',
      contentValue: `{{ ${entity}priceCategory.code }}`,
      description: 'templates.price_categories.code.description',
    },
    {
      label: 'templates.price_categories.name.label',
      contentValue: `{{ ${entity}priceCategory.name }}`,
      description: 'templates.price_categories.name.description',
    },
  ];
};

export const templatePriceCategory: EntityTemplateVariables = {
  fields: getPriceCategoryFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
